import useAxios from './use.axios';
import dateFieldValue from '../objects/models/date.field.value';
import { allow } from '../classes/allow';
import is from '../objects/is';
import the from '../objects/the';
import getDateStringFromObject from '../functions/get.date.string.from.object';
import { stripInvalidMbiChars } from '../functions/strip.invalid.mbi.chars';

export default function useVerifyAccountApi() {
    const axios = useAxios();

    const post = async (medicareNumber = '', lastName = '', dateOfBirth = dateFieldValue) => {
        allow.aString(medicareNumber, is.not.empty).aString(lastName, is.not.empty).anInstanceOf(dateOfBirth, dateFieldValue);
        return await axios.call(
            the.method.post,
            '/account/api/verify-account',
            {
                dateOfBirth: getDateStringFromObject(dateOfBirth),
                lastName,
                mbi: stripInvalidMbiChars(medicareNumber),
            },
            the.defaultHeader,
        );
    };

    return {
        post,
    };
}